<script lang="ts">
	let {
		content,
		variant = 'info',
		responsive = false,
		vertical = false
	}: {
		content?: string | null;
		variant?: 'warning' | 'danger' | 'info' | 'darker' | 'themed';
		responsive?: boolean;
		vertical?: boolean;
	} = $props();
</script>

{#if content}
	<div class={`StatusLabel text:xs ${variant}`} class:responsive class:vertical>
		<span>{content}</span>
	</div>
{/if}

<style lang="scss">
	div {
		font-size: 12px;
		line-height: 1.5em;
		padding: 4px 10px;
		background-color: $colorCardBackground;
		color: $colorCardForeground;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.vertical {
		padding: 10px 4px;
		display: flex;
		align-items: center;

		span {
			writing-mode: vertical-rl;
			text-orientation: mixed;
			transform: rotate(180deg);
		}
	}

	.responsive {
		height: 12px;
		width: 12px;
		padding: 0 !important;
		border-radius: 50%;

		span {
			display: none;
		}

		@include md {
			height: unset;
			width: unset;
			padding: 4px 10px !important;
			border-radius: unset;

			&.vertical {
				padding: 10px 4px !important;
			}

			span {
				display: inline;
			}
		}
	}

	.darker {
		background-color: $colorCardGraphic;
		color: $colorCardForeground;
	}

	.themed {
		background-color: var(--theme-primary);
		color: var(--theme-foreground);
		/* background-color: $colorCardGraphic;
		color: $colorCardForeground; */
	}

	.warning {
		background-color: $colorWarningBackground;
		color: $colorWarningForeground;
	}

	.danger {
		background-color: $colorDangerBackground;
		color: $colorDangerForeground;
	}
</style>
